import script from "./CategoriesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesTab.vue?vue&type=script&setup=true&lang=js"

import "./CategoriesTab.vue?vue&type=style&index=0&id=24cd16fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24cd16fc"]])

export default __exports__